export const SCD_TYPES: string[] = [
  'HbSS',
  'HbSC',
  'HbSβ-thal+',
  'HbSβ-thal0',
  'HbSD',
  'HbSE',
  'Not sure yet',
  'Prefer not to say',
];

export const SCD_TYPES_CIRCLE: string[] =
  SCD_TYPES.filter(t => t !== 'Not sure yet');

export const SCD_TYPES_FILTER: string[] =
  ['all', ...SCD_TYPES.filter(t => !['HbSD', 'HbSE', 'Not sure yet', 'Prefer not to say'].includes(t))];
